import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { CkEditorComponent } from '../../../shared/ck-editor/ck-editor.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { FormService } from '../../../shared/form.service';
import { PassageService } from '../passage.service';
import { PassageModel, PassageRequest } from '@generativ/much-smarter-models';
import { AlertService } from '../../../core/alert/alert.service';
import { Observable } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ...MATERIAL_IMPORTS, CapitalizePipe, CkEditorComponent],
  selector: 'app-passage',
  templateUrl: './passage.component.html',
  styleUrls: ['./passage.component.scss']
})
export class PassageComponent implements OnInit {

  passageId: number;
  passageForm: FormGroup;
  pageType: string;
  errorMessage: string;
  isSubmitting = false;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private passageService: PassageService,
              private alertService: AlertService,
              public formService: FormService) {
    this.passageForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.pageType = data.type;
      if (this.pageType === 'edit') {
        this.route.params.subscribe((params: Params) => {
          this.passageId = +params['passageId'];
          this.passageService.getPassage(this.passageId).subscribe(
            courseModel => {
              this.passageForm.patchValue(courseModel);
            }
          );
        });
      }
    });
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.passageForm)) {
      let passageObservable: Observable<PassageModel>;
      let message: string;
      this.errorMessage = null;

      if (this.isSubmitting) {
        return;
      }

      if (!this.passageForm.valid) {
        this.errorMessage = 'Errors on form. See fields below.';
        return;
      }

      this.isSubmitting = true;

      if (this.pageType === 'create') {
        const passage = new PassageRequest.Create();
        passage.parse(this.passageForm.value);
        message = 'Passage created';
        passageObservable = this.passageService.createPassage(passage);
      } else {
        const passage = new PassageRequest.Update();
        passage.parse(this.passageForm.value);
        message = 'Passage edited successfully';
        passageObservable = this.passageService.updatePassage(this.passageId, passage);
      }
      passageObservable.subscribe(
        passageModel => {
          if (this.pageType === 'create') {
            const redirectUrl =`../`;
            this.router.navigate([redirectUrl], {relativeTo: this.route});
          }
          this.alertService.success(message);
        },
        err => {
          this.isSubmitting = false;
          this.alertService.error(err);
        }
      );
    }
  }

  get buttonName(): string {
    return this.pageType === 'edit' ? 'SAVE' : this.pageType.toUpperCase();
  }

  private  get formOptions(): object {
    return {
      'title': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'content': [
        'Click here to edit',
        Validators.compose([
          Validators.maxLength(20000)
        ])
      ]
    };
  }
}
